import type { ClientMessage } from '@rabbitfuel/shared';

/** Kleines Kärtchen mit Kopf -- das Zeichen fuers Athleten-Pop-up. */
function PopupIcon() {
  return (
    <svg className="spot-btn__icon" viewBox="0 0 20 20" aria-hidden>
      <rect x="1.5" y="3.5" width="17" height="13" rx="2.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="7" cy="9" r="2.2" fill="currentColor" />
      <path d="M3.9 14.2c.6-1.6 1.7-2.4 3.1-2.4s2.5.8 3.1 2.4" fill="currentColor" />
      <path d="M11.8 8h4M11.8 11.3h3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

/**
 * Knopf „Pop-up einblenden" fuer eine Startnummer -- in der Startliste, in
 * „Auf der Strecke" und im Streckenkarten-Pult derselbe. Laeuft das Pop-up
 * dieser Person gerade, nimmt ein zweiter Druck es weg.
 */
export function SpotlightButton({
  bib,
  activeBib,
  send,
}: {
  bib: string;
  activeBib: string | null;
  send: (m: ClientMessage) => void;
}) {
  const on = Boolean(bib) && activeBib === bib;
  return (
    <button
      type="button"
      className={`spot-btn${on ? ' is-on' : ''}`}
      disabled={!bib}
      aria-pressed={on}
      title={
        !bib
          ? 'Ohne Startnummer gibt es kein Pop-up'
          : on
            ? 'Pop-up ausblenden'
            : 'Pop-up mit Foto und Netzwerken einblenden (5 Sekunden)'
      }
      onClick={() => send(on ? { t: 'spotlight:hide' } : { t: 'spotlight:show', bib })}
    >
      <PopupIcon />
    </button>
  );
}
